<script setup lang="ts">
import type { BlokPriceLists } from "@/.storyblok/types/120421/storyblok-components";

const props = defineProps<{
  blok: BlokPriceLists;
}>();

const activePriceListIndex = ref(0);
const activePriceList = computed(
  () => props.blok.content[activePriceListIndex.value]
);
</script>

<template>
  <BaseContentSection v-editable="blok" :background-color="blok.backgroundColor">
    <div class="mb-8">
      <BasePriceListTab
        v-for="(priceList, index) of blok.content"
        :key="priceList._uid"
        :text="priceList.title"
        :is-active="index === activePriceListIndex"
        @click="activePriceListIndex = index"
      ></BasePriceListTab>
    </div>
    <BlokPriceList
      v-if="activePriceList"
      :blok="activePriceList"
    ></BlokPriceList>
  </BaseContentSection>
</template>
